export function useRfqDemoMode() {
  const router = useRouter()

  return computed(() => router.currentRoute.value.meta.rfqDemo === true)
}
